import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import { TitleRequestStatusInfo } from "./Constant/Source";
import SourceEditForm from "./Forms/SourceEditForm";

const PbhRequestStatusEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={TitleRequestStatusInfo.edit} component="div">
      <SourceEditForm {...props} />
    </Edit>
  );
};

export default PbhRequestStatusEdit;
